import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
var Svg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  path {\n    fill: ", ";\n  }\n"], ["\n  cursor: ", ";\n  path {\n    fill: ", ";\n  }\n"])), function (_a) {
  var disabled = _a.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_a) {
  var theme = _a.theme,
      disabled = _a.disabled;
  return disabled && theme.colors.gray4;
});
var templateObject_1;
export { Svg };